<template>
  <div id="app">
    <keep-alive>
      <router-view class="children_view" :class="{'scroll_view': scrollView}" ref="children_view" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>

    <router-view class="children_view" :class="{'scroll_view': scrollView}" ref="children_view" v-if="!$route.meta.keepAlive"></router-view>

    <modal></modal>
    <toast></toast>
  </div>
</template>

<script>
import modal from "./components/modal";
import toast from "./components/toast";
import loading from "./components/loading";
export default {
  name: "App",
  data() {
    return {
      scrollRouteArr: [
        'demo',
        'classify',
        'guahaoRecord',
        'index',
        'supervisor'
      ],
      scrollView: false
    };
  },
  components: {
    modal,
    toast,
    loading,
  },
  beforeMount () {
    let u = navigator.userAgent;
    this.scrollView = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios
    (function() {
        if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
            handleFontSize();
        } else {
            if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
            } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                document.attachEvent("onWeixinJSBridgeReady", handleFontSize);  }
        }
        function handleFontSize() {
            // 设置网页字体为默认大小
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
            // 重写设置网页字体大小的事件
            WeixinJSBridge.on('menu:setfont', function() {
                WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });
            });
        }
    })();
  },
  mounted(e) {
    document.getElementById("app").addEventListener("scroll", this.toggleHead);
  },
  watch: {
    // 监听路由变化，关闭组件
    $route (to, from) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.hideModal();
      this.$store.commit("beDefault", {});
    }
  },
  methods: {
    toggleHead(e) {
      if (this.scrollRouteArr.indexOf(this.$route.name) === -1) return false;
      let scrollBottom = document.getElementsByClassName("children_view")[0].clientHeight - document.getElementById("app").scrollTop - window.innerHeight;
      if (scrollBottom <= 100) this.$store.commit('setwithBottom', scrollBottom);
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/reset.scss";
@import "./assets/css/public.scss";
#app {
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  // position: relative;
  background: #fff;
  -webkit-overflow-scrolling: auto;
  .children_view {
    width: 100%;
    min-height: 100%;
    box-sizing: border-box;
    transition: all 350ms;
    // &.scroll_view{
    //   min-height:calc(100% + 1px);
    // }
  }
  .public_no_data {
    text-align: center;
    color: #999;
    font-size: 28px;
    padding: 400px 0 150px;
  }
  .public_no_more {
    text-align: center;
    color: #999;
    font-size: 24px;
    padding: 10px 0;
  }
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ellipsisMore {
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .ellipsisMore3 {
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .van-popup{
    background:none;
  }
  .van-picker__toolbar{
    line-height:88px;
    height:88px;
    .van-picker__cancel, .van-picker__confirm {
      font-size:30px;
    }
  }
  .van-picker-column{
    font-size:30px !important;
  }
  .van-picker__title{
    font-size:30px;
  }
}
.van-image-preview__image{
  width: 100% !important;
  height: 100% !important;
}
.van-image__img{
  object-fit: fill !important;
  width: 100% !important;
  height: 100% !important;
}
.van-picker__title{
  line-height:50px !important;
}
</style>
